import React, { useCallback, useState, useEffect } from 'react';
import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
// import { useRouteMatch } from 'react-router-dom';
import SimpleDropDown from './../../components/SimpleDropDown';
import Cookies from 'js-cookie';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Grid from '@material-ui/core/Grid';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
  useRouteMatch,
  useHistory,
} from 'react-router-dom';

const theme = createTheme({
  // palette: {
  //   primary: { main: '#f56565' },
  // },
});
const jwt = require('jsonwebtoken');
const axios = require('axios');

const Admin = ({ currentOrganisation, userLists, setPage, refreshData }) => {
  let history = useHistory();
  let dataLoaded = currentOrganisation && userLists;
  let [deletedUserID, setDeletedUserID] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState(false);
  const [open, setOpen] = useState(false);
  const [refreshUserLists, setUserLists] = useState(false);
  const [confirmed, setConfirm] = useState(false);
  const handleClickOpen = (params) => {
    setOpen(true);
    let username = params.row.username;
    setSelectedUserName(username);
  };

  useEffect(() => {
    setConfirm(false);
    let authObj = Cookies.get('authObj');
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj['token'];
    }

    let apiKeys = {
      admin: 'jnjirej9reinvuiriuerhuinui',
      serviceUser: 'juit959fjji44jcion4moij0kc',
    };

    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
        apikey: apiKeys['admin'],
      },
    };

    let body = {
      userid: deletedUserID,
    };

    axios
      .post(`${process.env.REACT_APP_API}/deleteUser`, body, config)
      .then((result) => {
        console.log(result);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${process.env.REACT_APP_API}/listOfUsers`, config)
      .then((response) => {
        setUserLists(response.data.userLists);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [confirmed]);

  userLists = refreshUserLists || userLists;
  const handleCloseAndConfirm = () => {
    setOpen(false);
    setConfirm(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (refreshData) {
      window.location.reload();
    }
  }, []);

  let handleEditCellChangeCommitted = useCallback((event) => {
    let oldRecord = userLists.find((user) => user.id === event.id);
    let changedField = event.field;
    let newRecord = oldRecord;
    newRecord[changedField] = event.props.value;
    let apiKeys = {
      admin: 'jnjirej9reinvuiriuerhuinui',
      serviceUser: 'juit959fjji44jcion4moij0kc',
    };
    let authObj = Cookies.get('authObj');
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj['token'];
    }

    let config = {
      headers: { Authorization: `Bearer ${token}`, apikey: apiKeys['admin'] },
    };

    newRecord['userid'] = newRecord['id'];
    newRecord['password'] = '';
    axios
      .post(`${process.env.REACT_APP_API}/edituser`, newRecord, config)
      .then((result) => {
        console.log(result);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // window.location.reload(refreshData);

  if (dataLoaded) {
    userLists = userLists.filter(
      (users) => users.organisation === currentOrganisation
    );

    let accessL = Cookies.get('accessLvl') || false;

    if (accessL) {
      accessL = JSON.parse(accessL);
      userLists = userLists.map((user) => {
        let { accessLvl, userid } = accessL;
        if (user.id === userid) {
          user['userType'] = accessLvl;
        }
        return user;
      });
    }

    // if (confirmed) {
    //   window.location.reload();
    //   // userLists = userLists.filter((user) => user.id !== deletedUserID);
    // }

    let columns = [
      {
        editable: false,
        hide: true,
        headerName: 'User Org',
        field: 'organsation',
        width: 140,
      },
      {
        editable: false,
        hide: true,
        headerName: 'User ID',
        field: 'id',
        width: 140,
      },
      {
        editable: false,
        hide: false,
        headerName: 'User Name',
        field: 'username',
        width: 170,
      },
      {
        editable: false,
        hide: false,
        headerName: 'User Email',
        field: 'email',
        width: 250,
      },
      {
        editable: true,
        hide: false,
        headerName: 'Access',
        field: 'userType',
        width: 140,
        renderEditCell: (params) => {
          // console.log(params.row.userType);
          let userParams = params.row;
          return <SimpleDropDown userParams={userParams} />;
        },
      },
      {
        field: 'edit',
        headerName: 'Edit User',
        width: 150,
        renderCell: (params) => {
          return (
            <EditIcon
              color={'primary'}
              style={{ cursor: 'pointer' }}
              fontSize={'small'}
            />
          );
        },
      },
      {
        field: 'revoke',
        headerName: 'Revoke',
        width: 150,
        renderCell: (params) => {
          return (
            <div>
              <DeleteIcon
                color={'primary'}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  handleClickOpen(params);
                }}
              />
            </div>
          );
        },
      },
    ];

    let datagridData = { columns: columns, rows: userLists };
    let diagloueContentText = (
      <DialogContentText>
        <span>
          Are you sure to revoke this user <strong>{selectedUserName}</strong>
        </span>
      </DialogContentText>
    );
    return (
      <div style={{ height: 620 }}>
        <ThemeProvider theme={theme}>
          <Grid container spacing={1}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'right',
              }}
              item
              xs={12}>
              <span
                onClick={() => {
                  history.push(`/dashboard/adminAddUser`);
                }}
                style={{ cursor: 'pointer' }}>
                <PersonAddIcon color={'primary'} />
              </span>
            </Grid>
          </Grid>
          <div>&nbsp;</div>
          <DataGrid
            {...datagridData}
            onCellClick={(event) => {
              let field = event.field;
              if (field === 'revoke') {
                setDeletedUserID(event.id);
              }

              if (field === 'edit') {
                let userid = event.id;
                Cookies.set('page', `Edit User`);
                let authObj = Cookies.get('authObj');
                authObj = JSON.parse(authObj);
                let { token } = authObj;
                jwt.verify(
                  token,
                  '6jFLnuPANxk4UzePcRSTRkwXSqxhAMf2FAm4VFvV',
                  (err, decoded) => {
                    let { userid: selfId } = decoded;

                    if (selfId === userid) {
                      history.push(`/dashboard/editProfile`);
                    } else {
                      history.push(`/dashboard/adminEditUser/${userid}`);
                    }
                  }
                );
              }
            }}
            onEditCellChangeCommitted={handleEditCellChangeCommitted}
            filterModel={{
              items: [
                // {
                //   columnField: 'commodity',
                //   operatorValue: 'contains',
                //   value: 'rice',
                // },
              ],
            }}
          />
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'>
            {/* <DialogTitle id='form-dialog-title'>Subscribe</DialogTitle> */}
            <DialogContent>{diagloueContentText}</DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color='primary'>
                Cancel
              </Button>
              <Button onClick={handleCloseAndConfirm} color='primary'>
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    );
  } else {
    return <h1>Loading all users data....</h1>;
  }
};

export default Admin;
